import {
  FiBookOpen,
  FiHome,
  FiTrendingUp,
  FiBriefcase,
  FiUsers,
  FiGlobe,
  FiZap,
  FiAward,
} from 'react-icons/fi'
import type { Partner } from '@/types/partners'

export const partners: Partner[] = [
  { name: 'Education Partner', Icon: FiBookOpen },
  { name: 'Government Agency', Icon: FiHome },
  { name: 'Development Partner', Icon: FiTrendingUp },
  { name: 'Business Network', Icon: FiBriefcase },
  { name: 'Community Org', Icon: FiUsers },
  { name: 'Cultural Institute', Icon: FiGlobe },
  { name: 'Innovation Hub', Icon: FiZap },
  { name: 'Funding Partner', Icon: FiAward },
]
